import { mountHeaderFooter } from './header-footer.js';
import { mountEventIndex } from './event-index.js';

// Safari の透過バー用。safe-area を有効にする
const viewportMeta = document.querySelector('meta[name="viewport"]');
if (viewportMeta && !/viewport-fit\s*=\s*cover/.test(viewportMeta.content)) {
  viewportMeta.setAttribute('content', `${viewportMeta.content}, viewport-fit=cover`);
}

//if (!document.querySelector('meta[name="theme-color"]')) {
//  const themeColorMeta = document.createElement('meta');
//  themeColorMeta.name = 'theme-color';
//  themeColorMeta.content = '#fff';
//  document.head.appendChild(themeColorMeta);
//}

const pageContainer = document.querySelector('.l-container');
if (pageContainer && !pageContainer.querySelector('.l-container__chrome')) {
  pageContainer.insertAdjacentHTML('afterbegin', `
    <div class="l-container__chrome l-container__chrome--top" aria-hidden="true"></div>
    <div class="l-container__chrome l-container__chrome--bottom" aria-hidden="true"></div>
  `);
}

// 共通ヘッダー・フッターとイベント一覧を描画する
mountHeaderFooter();
mountEventIndex();

// 関連エリアがあるページにボディクラスを付ける
if (document.querySelector('.l-page-relation')) {
  document.body.classList.add('has-relation-area');
}

// 画像モーダルの生成と開閉を制御する
const imageModalTriggers = document.querySelectorAll('.js-imagemodal');

if (imageModalTriggers.length) {
  const modal = document.createElement('div');
  modal.className = 'c-imagemodal';
  modal.hidden = true;
  modal.innerHTML = `
    <div class="c-imagemodal__box" role="dialog" aria-modal="true" aria-label="画像">
      <button type="button" class="c-imagemodal__close" aria-label="閉じる"></button>
      <img class="c-imagemodal__image" src="" alt="">
    </div>
  `;
  document.body.appendChild(modal);

  const box = modal.querySelector('.c-imagemodal__box');
  const image = modal.querySelector('.c-imagemodal__image');
  const closeButton = modal.querySelector('.c-imagemodal__close');
  const pcQuery = window.matchMedia('(min-width: 600px)');
  let requestId = 0;
  let onFadeOut = null;
  let pcMaxWidth = 0;

  // PCは指定幅、それ以外は画面幅いっぱいに画像サイズを合わせる
  const applySize = () => {
    const width = pcMaxWidth || image.naturalWidth / 2;

    if (pcQuery.matches && width) {
      image.style.width = `${width}px`;
      box.style.width = '';
      return;
    }

    image.style.width = '100%';
    box.style.width = '100%';
  };

  // フェードアウト後にモーダルを非表示にして状態を戻す
  const finishClose = () => {
    if (modal.classList.contains('is-open')) return;

    modal.hidden = true;
    image.removeAttribute('src');
    image.style.width = '';
    box.style.width = '';
    pcMaxWidth = 0;
    document.body.style.overflow = '';
  };

  // 画像の読み込み後にモーダルを開く
  const openModal = (src, maxWidth) => {
    const current = ++requestId;
    pcMaxWidth = maxWidth;

    // 最新の要求ならモーダルを表示する
    const show = () => {
      if (current !== requestId) return;

      if (onFadeOut) {
        modal.removeEventListener('transitionend', onFadeOut);
        onFadeOut = null;
      }

      applySize();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (current !== requestId) return;
          modal.classList.add('is-open');
        });
      });
    };

    image.addEventListener('load', show, { once: true });
    image.src = src;
  };

  // モーダルをフェードアウトして閉じる
  const closeModal = () => {
    if (modal.hidden || !modal.classList.contains('is-open')) return;

    requestId += 1;
    modal.classList.remove('is-open');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClose();
      return;
    }

    onFadeOut = (event) => {
      if (event.target !== modal || event.propertyName !== 'opacity') return;
      modal.removeEventListener('transitionend', onFadeOut);
      onFadeOut = null;
      finishClose();
    };
    modal.addEventListener('transitionend', onFadeOut);
  };

  imageModalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const maxWidth = parseFloat(trigger.dataset.pcMaxWidth);
      openModal(trigger.getAttribute('href'), Number.isFinite(maxWidth) && maxWidth > 0 ? maxWidth : 0);
    });
  });

  closeButton.addEventListener('click', closeModal);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  window.addEventListener('resize', () => {
    if (!modal.hidden) {
      applySize();
    }
  });
}

// ヘッダーメニューの開閉と内部アコーディオンを制御する
const headerSwitch = document.querySelector('.js-header-switch');
const headerMenu = document.querySelector('.l-header');

if (headerSwitch && headerMenu) {
  // アニメーション軽減が有効かを返す
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let headerCloseTimer = 0;

  // 閉じアニメーション後にメニューを描画ツリーから外す
  const hideHeaderAfterClose = () => {
    if (!headerMenu.classList.contains('is-open')) {
      headerMenu.hidden = true;
    }
  };

  // ヘッダーメニューの開閉状態を切り替える
  const setHeaderOpen = (isOpen) => {
    window.clearTimeout(headerCloseTimer);
    headerSwitch.classList.toggle('is-open', isOpen);
    headerSwitch.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (isOpen) {
      headerMenu.hidden = false;
      void headerMenu.offsetHeight;
      headerMenu.classList.add('is-open');
      return;
    }

    headerMenu.classList.remove('is-open');

    if (reduceMotion()) {
      hideHeaderAfterClose();
      return;
    }

    headerCloseTimer = window.setTimeout(hideHeaderAfterClose, 450);
  };

  headerSwitch.addEventListener('click', () => {
    setHeaderOpen(!headerMenu.classList.contains('is-open'));
  });

  headerMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      setHeaderOpen(false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && headerMenu.classList.contains('is-open')) {
      setHeaderOpen(false);
    }
  });

  const accordion = headerMenu.querySelector('.l-header__accordion');
  const accordionBody = accordion ? accordion.querySelector('.l-header__sub') : null;
  const accordionSummary = accordion ? accordion.querySelector('summary') : null;

  if (accordion && accordionBody && accordionSummary) {
    let onAccordionEnd = null;

    // 高さアニメーション完了時の処理を解除する
    const clearAccordionEnd = () => {
      if (!onAccordionEnd) return;
      accordionBody.removeEventListener('transitionend', onAccordionEnd);
      onAccordionEnd = null;
    };

    accordionSummary.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !accordion.classList.contains('is-open');
      accordion.classList.toggle('is-open', willOpen);
      clearAccordionEnd();

      if (reduceMotion()) {
        accordion.open = willOpen;
        accordionBody.style.height = willOpen ? 'auto' : '0px';
        return;
      }

      if (willOpen) {
        accordion.open = true;
        accordionBody.style.height = 'auto';
        const target = accordionBody.scrollHeight;
        accordionBody.style.height = '0px';
        accordionBody.offsetHeight;
        accordionBody.style.height = `${target}px`;
        onAccordionEnd = (endEvent) => {
          if (endEvent.propertyName !== 'height') return;
          accordionBody.style.height = 'auto';
          clearAccordionEnd();
        };
        accordionBody.addEventListener('transitionend', onAccordionEnd);
        return;
      }

      accordionBody.style.height = `${accordionBody.scrollHeight}px`;
      accordionBody.offsetHeight;
      accordionBody.style.height = '0px';
      onAccordionEnd = (endEvent) => {
        if (endEvent.propertyName !== 'height') return;
        accordion.open = false;
        clearAccordionEnd();
      };
      accordionBody.addEventListener('transitionend', onAccordionEnd);
    });
  }
}

// ページ内アコーディオンの開閉アニメーションを付ける
document.querySelectorAll('details.js-accordion').forEach((accordion) => {
  const summary = accordion.querySelector('summary');
  const body = accordion.querySelector('.c-accordion__body');
  if (!summary || !body) return;

  let onEnd = null;
  // アニメーション軽減が有効かを返す
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 高さアニメーション完了時の処理を解除する
  const clearEnd = () => {
    if (!onEnd) return;
    body.removeEventListener('transitionend', onEnd);
    onEnd = null;
  };

  accordion.classList.toggle('is-open', accordion.open);
  if (!accordion.open) {
    body.style.height = '0px';
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    const willOpen = !accordion.classList.contains('is-open');
    accordion.classList.toggle('is-open', willOpen);
    clearEnd();

    if (reduceMotion()) {
      accordion.open = willOpen;
      body.style.height = willOpen ? 'auto' : '0px';
      return;
    }

    if (willOpen) {
      accordion.open = true;
      body.style.height = 'auto';
      const target = body.scrollHeight;
      body.style.height = '0px';
      body.offsetHeight;
      body.style.height = `${target}px`;
      onEnd = (endEvent) => {
        if (endEvent.propertyName !== 'height') return;
        body.style.height = 'auto';
        clearEnd();
      };
      body.addEventListener('transitionend', onEnd);
      return;
    }

    body.style.height = `${body.scrollHeight}px`;
    body.offsetHeight;
    body.style.height = '0px';
    onEnd = (endEvent) => {
      if (endEvent.propertyName !== 'height') return;
      accordion.open = false;
      clearEnd();
    };
    body.addEventListener('transitionend', onEnd);
  });
});

// 商品スライダーを初期化する
document.querySelectorAll('.js-productslider').forEach((slider) => {
  if (typeof Swiper === 'undefined') return;

  const root = slider.closest('.c-productslider');
  if (!root) return;

  const pcQuery = window.matchMedia('(min-width: 600px)');
  // アニメーション軽減が有効かを返す
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // 画面幅に応じたスライド間隔を返す
  const spaceBetween = () => (pcQuery.matches ? 24 : (17 / 390) * window.innerWidth);

  const swiper = new Swiper(slider, {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: spaceBetween(),
    loop: true,
    speed: reduceMotion() ? 0 : 400,
    slideToClickedSlide: true,
    navigation: {
      prevEl: root.querySelector('.c-productslider__prev'),
      nextEl: root.querySelector('.c-productslider__next'),
    },
    pagination: {
      el: root.querySelector('.c-productslider__fraction'),
      type: 'fraction',
    },
  });

  window.addEventListener('resize', () => {
    swiper.params.spaceBetween = spaceBetween();
    swiper.params.speed = reduceMotion() ? 0 : 400;
    swiper.update();
  });
});

const scrollTopButtons = document.querySelectorAll('.js-scroll-top');

// 続きを読むボタンで本文を展開する
document.querySelectorAll('.js-readmore').forEach((root) => {
  const button = root.querySelector('.c-accordion__more');
  if (!button) return;

  button.addEventListener('click', () => {
    root.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
  });
});

// ページ先頭へスクロールする
scrollTopButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  });
});



// TOPページ特有の処理
const topPage = () => {

  //TOPページでのみ実行
  const top = document.querySelector('.js-top');
  if (!top) return;

  const tl = gsap.timeline();

  tl.fromTo('.top-mv__catch',{
      opacity: 0,
      scale: 2.0,
  },{
    opacity: 1,
    scale: 1,
    duration: 0.8,
    ease: 'power4.inOut',
  });
  tl.fromTo('.top-mv__player', {
    opacity: 0,
    scale: 1.1,
  },{
    opacity: 1,
    scale: 1,
    duration: 1.0,
    ease: 'power4.inOut',
  },"-=0.4");

  tl.fromTo('.top-mv__title',{
    opacity: 0,
    y:15
  },{
    opacity: 1,
    y:0,
    duration: 0.8,
    ease: 'power4.inOut',
  },"-=0.3");

  tl.play();


  // 各グループ1個のボールが、スクロールに合わせて画面外から斜め下へ転がり、画面外へ出る
  // js-top-ball--reverse は左上から右下。付いていなければ右上から左下
  const topBalls = gsap.utils.toArray('.js-top-ball');
  if (topBalls.length && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const spQuery = window.matchMedia('(max-width: 599px)');
    let cleanups = [];

    const setupTopBalls = () => {
      cleanups.forEach((fn) => fn());
      cleanups = [];

      const isSp = spQuery.matches;

      topBalls.forEach((el) => {
        const bg = el.closest('.top-ballbg');
        const stage = el.parentElement;
        if (!bg || !stage || bg.getClientRects().length === 0) return;

        const toLeft = !el.classList.contains('js-top-ball--reverse');
        const isIntro = bg.classList.contains('top-ballbg--intro');
        const isIntro2 = bg.classList.contains('top-ballbg--intro2');

        // セクション内の座標で、はみ出た分は overflow で隠す
        const place = (progress) => {
          const amount = gsap.utils.clamp(0, 1, progress);
          const width = stage.offsetWidth || window.innerWidth;
          const height = stage.offsetHeight || window.innerHeight;
          const size = el.offsetWidth || 1;
          const pad = size * 0.45;
          const run = width + size + pad;
          const drop = Math.max(size * 1.1, Math.min(height * 0.7, run * 0.4));
          const yShift = isIntro2 ? Math.max(0, height - drop - pad) * 0.75 : 0;
          const x0 = toLeft ? width + pad * 0.2 : -size - pad * 0.2;
          const x1 = toLeft ? -size - pad : width + pad;
          const y0 = -pad + yShift;
          const y1 = y0 + drop;
          const distance = Math.hypot(x1 - x0, y1 - y0) * amount;
          const spins = distance / (Math.PI * size);

          gsap.set(el, {
            x: x0 + (x1 - x0) * amount,
            y: y0 + (y1 - y0) * amount,
            rotation: (toLeft ? -1 : 1) * spins * 360,
            transformOrigin: '50% 50%',
          });
        };

        if (reducedMotion) {
          const size = el.offsetWidth || 1;
          gsap.set(el, {
            position: 'absolute',
            x: toLeft ? stage.offsetWidth * 0.62 : size,
            y: stage.offsetHeight * 0.22,
            rotation: 0,
            transformOrigin: '50% 50%',
          });
          return;
        }

        const docTop = () => bg.getBoundingClientRect().top + window.scrollY;
        const scrollRange = () => {
          const top = docTop();
          const vh = window.innerHeight;
          const max = ScrollTrigger.maxScroll(window);
          const height = bg.offsetHeight;
          const visibleStart = Math.max(0, top - vh);
          const visibleEnd = Math.min(max, top + Math.max(height, 1));
          const visibleSpan = Math.max(1, visibleEnd - visibleStart);
          let start = visibleStart;
          let end = visibleEnd;

          if (isSp && isIntro2) {
            // セクションが見えている後半で、下側の軌道を通す
            start = visibleStart + visibleSpan * 0.28;
            end = visibleEnd;
          } else if (isSp && isIntro) {
            start = Math.max(0, visibleStart - vh * 0.2);
            end = visibleStart + visibleSpan * 0.68;
          } else if (isIntro) {
            // お知らせはセクションに入る少し前から転がし始める
            start = Math.max(0, visibleStart - vh * 0.45);
            end = visibleEnd;
          } else if (visibleSpan < vh * 1.8) {
            // 低いセクションは開始を早めて、通り切るまでのスクロールを伸ばす
            start = Math.max(0, visibleEnd - vh * 1.8);
            end = visibleEnd;
          }

          if (end <= start) end = start + 1;
          return { start, end };
        };
        const motion = { p: 0 };
        // スクロールをすぐには追いつかせず、転がりながら減速する
        const rollTo = gsap.quickTo(motion, 'p', {
          duration: 1.7,
          ease: 'power3.out',
          onUpdate: () => place(motion.p),
        });
        const trigger = ScrollTrigger.create({
          trigger: bg,
          start: () => scrollRange().start,
          end: () => scrollRange().end,
          invalidateOnRefresh: true,
          onUpdate: (self) => rollTo(self.progress),
        });

        motion.p = trigger.progress;
        place(motion.p);

        cleanups.push(() => {
          trigger.kill();
          gsap.killTweensOf(motion);
        });
      });
    };

    setupTopBalls();
    spQuery.addEventListener('change', setupTopBalls);
    window.addEventListener('load', () => ScrollTrigger.refresh());
  }

  // 照明の固定レイヤーを、イベントセクションが見えている間だけ画面上に留める
  const eventSection = document.querySelector('.top-event');
  const eventLightFixed = eventSection && eventSection.querySelector('.top-event-light__fixed');
  if (
    eventSection &&
    eventLightFixed &&
    typeof ScrollTrigger !== 'undefined' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.create({
      trigger: eventSection,
      pin: eventLightFixed,
      pinSpacing: false,
      pinType: 'transform',
      start: 'top top',
      end: 'bottom bottom',
      invalidateOnRefresh: true,
    });
  }

  // 光の玉をランダムに置いて、その場でふわふわさせる
  const eventLightScroll = eventSection && eventSection.querySelector('.top-event-light__scroll');
  const eventLightImage = eventLightScroll && eventLightScroll.querySelector('img');
  if (
    eventLightScroll &&
    eventLightImage &&
    typeof gsap !== 'undefined' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    // bg_event_02_02.webp（3066×2348）内の光の玉
    const lightOrbs = [
      { x: 2856, y: 2160, w: 144, h: 146 },
      { x: 68, y: 586, w: 144, h: 144 },
      { x: 2776, y: 1528, w: 96, h: 96 },
      { x: 196, y: 0, w: 96, h: 88 },
      { x: 58, y: 1866, w: 84, h: 86 },
      { x: 2926, y: 386, w: 86, h: 84 },
      { x: 2630, y: 1942, w: 84, h: 86 },
      { x: 366, y: 1820, w: 76, h: 76 },
      { x: 2602, y: 340, w: 76, h: 76 },
      { x: 410, y: 426, w: 70, h: 72 },
      { x: 2752, y: 154, w: 52, h: 52 },
      { x: 264, y: 1594, w: 52, h: 52 },
      { x: 2788, y: 826, w: 48, h: 50 },
      { x: 232, y: 2308, w: 50, h: 40 },
      { x: 0, y: 2080, w: 38, h: 48 },
      { x: 3030, y: 558, w: 36, h: 50 },
      { x: 2634, y: 108, w: 36, h: 36 },
      { x: 352, y: 1544, w: 36, h: 36 },
    ];
    const sourceWidth = 3066;
    const sourceHeight = 2348;

    const isSp = window.matchMedia('(max-width: 599px)').matches;

    const hoverInPlace = (el, place) => {
      const driftX = isSp ? gsap.utils.random(6, 16) : gsap.utils.random(40, 90);
      const driftY = isSp ? gsap.utils.random(28, 64) : gsap.utils.random(56, 120);
      const pos = {
        x: 0,
        y: 0,
        opacity: gsap.utils.random(0.45, 0.85),
        scale: 1,
        transformOrigin: '50% 50%',
      };

      if (place) {
        pos.top = place.top;
        if (place.side === 'left') {
          pos.left = place.edge;
          pos.right = 'auto';
        } else {
          pos.left = 'auto';
          pos.right = place.edge;
        }
      } else {
        pos.left = `${gsap.utils.random(6, 82)}%`;
        pos.top = `${gsap.utils.random(8, 84)}%`;
      }

      gsap.set(el, pos);

      gsap.fromTo(el, {
        x: -driftX,
      }, {
        x: driftX,
        duration: gsap.utils.random(3.2, 5.4),
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
        delay: gsap.utils.random(0, 2),
      });
      gsap.fromTo(el, {
        y: -driftY,
      }, {
        y: driftY,
        duration: gsap.utils.random(3.6, 6),
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
        delay: gsap.utils.random(0, 2),
      });
      gsap.fromTo(el, {
        scale: gsap.utils.random(0.72, 0.86),
      }, {
        scale: gsap.utils.random(1.05, 1.2),
        duration: gsap.utils.random(2.4, 4.2),
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
        delay: gsap.utils.random(0, 1.5),
      });
      gsap.fromTo(el, {
        opacity: gsap.utils.random(0.2, 0.4),
      }, {
        opacity: gsap.utils.random(0.75, 1),
        duration: gsap.utils.random(2.2, 3.8),
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
        delay: gsap.utils.random(0, 1.5),
      });
    };

    const mountOrbs = () => {
      const scale = eventLightScroll.offsetWidth / sourceWidth;
      if (!scale) {
        requestAnimationFrame(mountOrbs);
        return;
      }
      eventLightScroll.classList.add('is-orbs');
      const isNarrow = window.matchMedia('(max-width: 599px)').matches;
      const pool = isNarrow ? lightOrbs.filter((orb) => orb.w >= 70) : lightOrbs;
      const total = isNarrow ? 32 : pool.length;
      const drawScale = scale * (isNarrow ? 2.0 : 1);
      const rows = Math.ceil(total / 2);

      for (let i = 0; i < total; i += 1) {
        const orb = pool[i % pool.length];
        const el = document.createElement('span');
        el.className = 'top-event-light__orb';
        el.style.backgroundImage = `url("${eventLightImage.currentSrc || eventLightImage.src}")`;
        el.style.backgroundSize = `${sourceWidth * drawScale}px ${sourceHeight * drawScale}px`;
        el.style.backgroundPosition = `${-orb.x * drawScale}px ${-orb.y * drawScale}px`;
        el.style.width = `${orb.w * drawScale}px`;
        el.style.height = `${orb.h * drawScale}px`;
        eventLightScroll.appendChild(el);

        if (!isNarrow) {
          hoverInPlace(el);
          continue;
        }

        const row = Math.floor(i / 2);
        const top = gsap.utils.clamp(4, 94, ((row + 0.5) / rows) * 90 + gsap.utils.random(-2, 2));
        hoverInPlace(el, {
          side: i % 2 === 0 ? 'left' : 'right',
          edge: `${gsap.utils.random(0, 1.5)}%`,
          top: `${top}%`,
        });
      }
    };

    if (eventLightImage.complete && eventLightImage.naturalWidth) mountOrbs();
    else eventLightImage.addEventListener('load', mountOrbs, { once: true });
  }

  // 色ごとに切り出した紙片を、原寸以下の大きさでひらひら落とす
  const paperField = document.querySelector('.top-intro-paper');
  if (
    paperField &&
    typeof gsap !== 'undefined' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    const isSp = window.matchMedia('(max-width: 599px)').matches;
    const flakeSrcs = [
      '/special/thanks/assets/image/top/bg_paper_01_01.webp',
      '/special/thanks/assets/image/top/bg_paper_01_02.webp',
      '/special/thanks/assets/image/top/bg_paper_01_03.webp',
      '/special/thanks/assets/image/top/bg_paper_01_04.webp',
    ];

    const fallThrough = (el) => {
      const play = (initialProgress) => {
        const height = paperField.offsetHeight || window.innerHeight;
        const size = el.offsetWidth || 28;
        const drift = gsap.utils.random(-150, 150);
        const duration = gsap.utils.random(13, 18);
        const fade = 0.7;
        const rotFrom = gsap.utils.random(-40, 40);
        const spin = gsap.utils.random(160, 320) * (Math.random() < 0.5 ? -1 : 1);

        if (el._flutter) el._flutter.kill();

        gsap.set(el, {
          left: `${gsap.utils.random(0, 90)}%`,
          transformOrigin: '50% 50%',
          transformPerspective: 700,
        });

        el._flutter = gsap.to(el, {
          rotationY: gsap.utils.random(28, 70) * (Math.random() < 0.5 ? -1 : 1),
          duration: gsap.utils.random(0.7, 1.35),
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1,
        });

        const tl = gsap.timeline({ onComplete: () => play() });
        tl.fromTo(el, {
          y: -size * 1.6,
          x: -drift * 0.2,
          rotation: rotFrom,
        }, {
          y: height + size,
          x: drift,
          rotation: rotFrom + spin,
          duration,
          ease: 'power1.in',
        }, 0);
        tl.fromTo(el, {
          opacity: 0,
        }, {
          opacity: 0.95,
          duration: fade,
          ease: 'sine.out',
        }, 0);
        tl.to(el, {
          opacity: 0,
          duration: fade,
          ease: 'sine.in',
        }, Math.max(0, duration - fade));

        if (initialProgress) tl.progress(initialProgress);
      };

      play(gsap.utils.random(0.05, 0.92));
    };

    const flakeTotal = isSp ? 18 : 28;
    for (let i = 0; i < flakeTotal; i += 1) {
      const flake = document.createElement('img');
      flake.className = 'top-intro-paper__flake';
      flake.alt = '';
      flake.setAttribute('aria-hidden', 'true');
      flake.src = flakeSrcs[i % flakeSrcs.length];
      paperField.appendChild(flake);

      const start = () => {
        const natural = flake.naturalWidth || 32;
        const ratio = gsap.utils.random(0.45, 1) * (isSp ? 0.55 : 1);
        flake.style.width = `${Math.max(isSp ? 7 : 10, Math.round(natural * ratio))}px`;
        fallThrough(flake);
      };

      if (flake.complete && flake.naturalWidth) start();
      else flake.addEventListener('load', start, { once: true });
    }
  }


}

topPage();


// TOPページ特有の処理
const fixcv = () => {
  const fixcvTarget = document.querySelector('.l-footer-fixcv__inner');
  if (fixcvTarget) {
    // アニメーションタイムライン（pauseで一時停止/再開に備える）
    const timeline = gsap.timeline({repeat: -1, repeatDelay: 1.7, paused: false});
    timeline.to(fixcvTarget, {
      x: -28,
      rotation: -40,
      duration: 1.15,
      ease: 'power2.out',
      transformOrigin: "50% 50%",
    });
    timeline.to(fixcvTarget, {
      x: 6,
      rotation: 8,
      duration: 0.44,
      ease: 'power1.inOut',
      transformOrigin: "50% 50%"
    });
    timeline.to(fixcvTarget, {
      x: 0,
      rotation: 0,
      duration: 0.30,
      ease: 'power1.out',
      transformOrigin: "50% 50%"
    });

    // scaleアニメーションのタイムライン
    const scaleTimeline = gsap.timeline({paused: true});
    scaleTimeline.to(fixcvTarget, {
      scale: 1.05,
      duration: 0.25,
      ease: 'power2.out'
    });

    // ホバー時のイベントリスナー
    fixcvTarget.addEventListener('mouseenter', () => {
      timeline.pause();
      scaleTimeline.play();
    });
    fixcvTarget.addEventListener('mouseleave', () => {
      scaleTimeline.reverse().then(() => {
        timeline.resume();
      });
    });
  }
}
fixcv();